module.exports = __webpack_public_path__ + "img/layout-9_3.3e830fb3.png";